// Format a Date as YYYY-MM-DD in the *local* timezone. Do not use
// `toISOString()` for this: it converts to UTC first, so a date the user
// picked at local midnight can land on the previous (or next) calendar day
// west/east of UTC, shifting the stats window by a day.
export function toLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
